export default "__VITE_ASSET__6aeb675b__"